import { Facebook, Instagram, Linkedin, LucideProps, Mail } from "lucide-react";
import React, { useEffect } from "react";
import { useActiveTab } from "./ActiveTabContext"; // Import the shared context

export const Logo = (props: LucideProps) => {
  return (
    <div>
      <img
        alt="Nuqi Logo"
        src={"/white-in-logo-cropped.png"}
        className={
          props && props.className
            ? props.className
            : "h-14 w-auto p-2 object-contain"
        }
      />
    </div>
  );
};

export function Footer() {
  const { activeTab, setActiveTab } = useActiveTab();

  useEffect(() => {
    const handleHashChange = () =>
      setActiveTab(window.location.pathname + window.location.hash);
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, [setActiveTab]);

  const handleScrollToSection = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    targetHash: string
  ) => {
    event.preventDefault();

    if (window.location.pathname !== "/") {
      window.location.href = `/${targetHash}`;
    } else {
      const target = document.querySelector(targetHash);
      target?.scrollIntoView({ behavior: "smooth" });
    }
    setActiveTab(`/${targetHash}`);
  };

  const isActive = (href: string) => activeTab === href;

  return (
    <footer className="bg-[#000] text-white -mt-20 font-poppins">
      <div className="container mx-auto px-4 py-10">
        {/* Logo and Social Media Section */}
        <div className="flex flex-col items-center mt-20 text-center text-white gap-10">
          <Logo className="h-14 w-auto" />
          <div className="flex gap-8">
            <a
              aria-label="Contact by Mail"
              className="text-[#57c0af] hover:text-primary-foreground transition"
              href="mailto:support@nuqiwealth.in"
            >
              <Mail className="w-6 h-6" />
            </a>
            <a
              aria-label="Follow on Instagram"
              className="text-[#57c0af] hover:text-primary-foreground transition"
              href="https://www.instagram.com/nuqiwealth_india/"
            >
              <Instagram className="w-6 h-6" />
            </a>
            <a
              aria-label="Follow on Facebook"
              className="text-[#57c0af] hover:text-primary-foreground transition"
              href="https://www.facebook.com/NuqiWealthIndia/"
            >
              <Facebook className="w-6 h-6" />
            </a>
            <a
              aria-label="Follow on Linkedin"
              className="text-[#57c0af] hover:text-primary-foreground transition"
              href="https://www.linkedin.com/company/nuqi-wealth"
            >
              <Linkedin className="w-6 h-6" />
            </a>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 xl:flex xl:justify-center gap-10 text-base font-poppins text-center">
          <a
            href="/"
            className={`${isActive("/")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={() => setActiveTab("/")}
          >
            Home
          </a>
          <a
            href="/#advisory"
            className={`${isActive("/#advisory")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={(e) => handleScrollToSection(e, "#advisory")}
          >
            Advisory
          </a>
          <a
            href="/#nuqiprive"
            className={`${isActive("/#nuqiprive")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={(e) => handleScrollToSection(e, "#nuqiprive")}
          >
            Prive
          </a>
          {/* <a
            href="/IRIS"
            className={`${isActive("/IRIS")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={() => setActiveTab("/IRIS")}
          >
            IRIS
          </a> */}
          <a
            href="/ethosphere"
            className={`${isActive("/ethosphere")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={() => setActiveTab("/ethosphere")}
          >
            Ethosphere
          </a>
          <a
            href="/Privacy"
            className={`${isActive("/Privacy")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={() => setActiveTab("/Privacy")}
          >
            Legal
          </a>
          <a
            href="/About"
            className={`${isActive("/About")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={() => setActiveTab("/About")}
          >
            About
          </a>
          {/* <a
            href="/partnership"
            className={`${isActive("/partnership")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={() => setActiveTab("/partnership")}
          >
            Partnership
          </a> */}
          <a
            href="/press"
            className={`${isActive("/press")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={() => setActiveTab("/press")}
          >
            News
          </a>
          <a
            href="/ContactsPage"
            className={`${isActive("/ContactsPage")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={() => setActiveTab("/ContactsPage")}
          >
            Contact Us
          </a>
          {/* <a
            href="/MonthlyComplaints"
            className={`${isActive("/MonthlyComplaints")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={() => setActiveTab("/MonthlyComplaints")}
          >
            Monthly Complaint
          </a> */}
          <a
            href="/InvestorCharter"
            className={`${isActive("/InvestorCharter")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={() => setActiveTab("/InvestorCharter")}
          >
            Investor Charter
          </a>
          {/* <a
            href="/partner-with-us"
            className={`${isActive("/partner-with-us")
              ? "text-[#57c0af] font-bold"
              : "text-white hover:text-[#57c0af]"
              }`}
            onClick={() => setActiveTab("/partner-with-us")}
          >
            Partner With Us
          </a> */}

        </div>

        {/* Disclaimer Section */}
        <div className="mt-10 text-center text-xs text-gray-400 leading-relaxed">
          <p>
            ©2025 Nuqi Wealth India Private Limited - Investment Advisory Unit (Separately Identifiable Unit) <br />
            SEBI RIA Registration No: INA000016612. CIN: U65990MH2020FTC351885. GSTIN: 27AAHCN3366N1ZW. Validity of registration- 30th Jan 2022 - Perpetual <br />Registered & Corporate Address: Unit No. 501, 5th Floor, Parinee I, Plot No. 7/A, Off Veera Desai Road, Andheri West, Mumbai - 400053<br />
            Disclaimer 1: Past performance is not a guarantee of future results. <br />The historical returns, expected returns, and probability projections provided on this website or App are for informational and illustrative purposes only.<br /> They are not an indication of future performance. All investing involves risk, including the possible loss of all the money you invest. The past performance of any trading system does not guarantee future performance. Nuqi Wealth assumes no responsibility for liability for your trading and investment results. Registration granted by SEBI is no way guarantee performance of the intermediary or provide any assurance of returns to investors.<br />
            Disclaimer 2: Registration granted by SEBI, membership of BASL and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors. <br />Advisory Services on Nuqiwealth.com is provided by Nuqi Wealth India Private Limited, a SEBI registered Investment Adviser having registration no. INA 000016612 (Valid from 31st Jan 2022 - Perpetual). BASL membership no 1750.
            <br /> <br /> <br />
            <span>
              Please visit our{" "}
              <a
                href="/disclaimer"
                target="_blank"
                className="underline underline-offset-2"
              >
                Disclaimer Notice page
              </a>{" "}
              for further information.
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}
